export const getCurrentDateTime = (): string => {
  const date = new Date()
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .replace('T', ' ')
    .replace('Z', '')
}
